import { Auth, API } from "aws-amplify";

export const getEventHistory = async (collection: string, id: string): Promise<any> => {
  const userSession = await Auth.currentSession();
  const token = userSession.getIdToken().getJwtToken();

  const response = await API.get("skytrains", `/history/${collection}/${id}/summary`, {
    headers: { Accept: "*/*", Authorization: token },
  });

  return response;
  // return response.map((item: any) => {
  //   Object.keys(item).forEach((key: string) => {
  //     const isTypeIndex = key.indexOf(".$");
  //     if (isTypeIndex >= 0) {
  //       const [fieldPath, fieldType] = [key.substring(0, isTypeIndex), key.substring(isTypeIndex + 1)];

  //       item[fieldPath] = {
  //         [fieldType]: item[key],
  //       };
  //       delete item[key];
  //     }
  //   });

  //   return item;
  // });
};
